import { createReducer, on } from '@ngrx/store';
import { Appointment } from '../../models/appointment.model';
import { AppointmentActions } from './appointment.actions';

export const appointmentFeatureKey = 'appointments';

export interface AppointmentState {
  items: Appointment[];
  loading: boolean;
  saving: boolean;
  submitted: boolean;
  error: string | null;
}

export const initialAppointmentState: AppointmentState = {
  items: [],
  loading: false,
  saving: false,
  submitted: false,
  error: null,
};

export const appointmentReducer = createReducer(
  initialAppointmentState,
  on(AppointmentActions.loadAppointments, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AppointmentActions.loadAppointmentsSuccess, (state, { appointments }) => ({
    ...state,
    items: appointments,
    loading: false,
  })),
  on(AppointmentActions.loadAppointmentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AppointmentActions.createAppointment, (state) => ({
    ...state,
    saving: true,
    submitted: false,
    error: null,
  })),
  on(AppointmentActions.createAppointmentSuccess, (state, { appointment }) => ({
    ...state,
    saving: false,
    submitted: true,
    items: [appointment, ...state.items],
  })),
  on(AppointmentActions.createAppointmentFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),
  on(AppointmentActions.updateAppointment, (state) => ({
    ...state,
    saving: true,
    error: null,
  })),
  on(AppointmentActions.updateAppointmentSuccess, (state, { appointment }) => ({
    ...state,
    saving: false,
    items: state.items.map((item) => (item._id === appointment._id ? appointment : item)),
  })),
  on(AppointmentActions.updateAppointmentFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),
  on(AppointmentActions.clearSubmissionState, (state) => ({
    ...state,
    submitted: false,
    error: null,
  })),
);
